import { createContext, useContext, useReducer } from 'react';

interface CartState {
  selectedItems: string[]; // 선택한 옵션의 Serial 목록
}

type CartAction =
  | { type: 'TOGGLE_ITEM'; payload: string }
  | { type: 'SELECT_ALL'; payload: string[] }
  | { type: 'CLEAR_ALL' };

const initialState: CartState = {
  selectedItems: [],
};

function cartReducer(state: CartState, action: CartAction): CartState {
  switch (action.type) {
    case 'TOGGLE_ITEM':
      return {
        ...state,
        selectedItems: state.selectedItems.includes(action.payload)
          ? [...state.selectedItems.filter(id => id !== action.payload)]
          : [...state.selectedItems, action.payload],
      };
    case 'SELECT_ALL':
      return { ...state, selectedItems: [...action.payload] };
    case 'CLEAR_ALL':
      return { ...state, selectedItems: [] };
    default:
      return state;
  }
}

const CartContext = createContext<{
  state: CartState;
  dispatch: React.Dispatch<CartAction>;
} | null>(null);

export function CartProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(cartReducer, initialState);

  return (
    <CartContext.Provider value={{ state, dispatch }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
}
